import LandingPage from '@/views/crm/LandingPage';
import TheCrm from '@/layouts/TheCrm';

const CRM_ROUTES = [
  {
    path: '/:brand_code/crm/landing_page',
    component: LandingPage
  }
];

export default CRM_ROUTES.map(item => {
  return {
    path: item.path,
    component: TheCrm,
    children: [
      {
        path: '',
        component: item.component
      }
    ]
  };
});
